import { gql } from '@apollo/client';

export default gql`
  mutation unblockMatch($input: UnblockMatchInput!) {
    unblockMatch(input: $input) {
      id
    }
  }
`;
